import { render, staticRenderFns } from "./scoreboard_football.vue?vue&type=template&id=60a8069c&scoped=true&"
import script from "./scoreboard_football.vue?vue&type=script&lang=js&"
export * from "./scoreboard_football.vue?vue&type=script&lang=js&"
import style0 from "./scoreboard_football.vue?vue&type=style&index=0&id=60a8069c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60a8069c",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {EventScoreboardFull: require('/var/web/bet777.es/components/event/scoreboard_full.vue').default})
